<template>
  <div>
    <div>
      <a-modal
        class="contact-modal"
        v-model="visibleModal"
        width="680px"
        title="添加参会人"
        :maskClosable="false"
        @cancel="handleCancel"
      >
        <div class="contact-modal-content">
          <div class="contact-tree-contanier">
            <div class="contact-tree-search">
              <a-input
                class="contact-tree-search-input"
                ref="searchInput"
                placeholder="搜索姓名、电话、分组搜索"
                allowClear
                size="large"
                @change="handleSearchChange"
                @keypress="handleSearchKeypressEnter"
                v-model="searchText"
              >
                <a-icon
                  slot="prefix"
                  type="search"
                  style="color: rgba(0,0,0,.45)"
                />
              </a-input>
              <div
                class="search-result"
                :class="showSearchResult ? 'search-result-show' : ''"
              >
                <div v-if="showSearchLoading" class="search-spin">
                  <a-spin />
                </div>
                <template v-if="searchResult.empty">
                  <div class="contact-choice-empty-search">
                    <svg-icon
                      class="contact-choice-empty-search-icon"
                      icon-class="empty-search"
                    />
                    <span>未搜索到联系人</span>
                  </div>
                </template>
                <template>
                  <div class="search-result-item-container">
                    <div
                      v-if="searchResultAddressRelationList.length > 0"
                      class="search-result-address-container"
                    >
                      <div class="search-result-container-header">
                        <span>联系人</span>
                      </div>
                      <div class="search-result-item-list">
                        <div
                          v-for="address in searchResultAddressRelationList"
                          :key="address.id"
                          class="search-result-item"
                        >
                          <div class="search-result-item-checkbox">
                            <a-checkbox
                              :checked="address.checked"
                              :disabled="address.disabled"
                              @change="
                                handleSearchAddressCheckboxClick(address)
                              "
                            ></a-checkbox>
                          </div>
                          <div
                            :style="{
                              'background-color': address.firstNameColor
                            }"
                            class="search-result-item-first-name"
                          >
                            {{ address.name.charAt(0) }}
                          </div>
                          <div class="search-item-body">
                            <span class="search-result-item-name">
                              {{ address.name }}
                            </span>
                            <span class="search-result-item-group">{{
                              address.showPhone
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="searchResultGroupRelationList.length > 0"
                    class="search-result-address-container"
                  >
                    <div class="search-result-container-header">
                      <span>分组</span>
                    </div>
                    <div class="search-result-item-list">
                      <div
                        v-for="group in searchResultGroupRelationList"
                        :key="group.id"
                        class="search-result-item"
                      >
                        <div class="search-result-item-checkbox">
                          <a-checkbox
                            :checked="group.checked"
                            @change="handleSearchGroupCheckboxClick(group)"
                          ></a-checkbox>
                        </div>
                        <svg-icon
                          class="search-result-item-group-icon"
                          icon-class="group"
                        />
                        <div class="search-item-body">
                          <div class="search-result-item-name">
                            {{ group.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="contact-tree">
              <div>
                <div class="contact-tree-head">
                  <svg-icon icon-class="enterprise-contact" />
                  <span>我的通讯录</span>
                </div>
                <div
                  data-role="root"
                  @click="bindClickTree"
                  class="contact-tree-body"
                >
                  <VirtualList
                    :items="treeOrderList"
                    :item-size="40"
                    ref="virtualList"
                    #default="{ items }"
                  >
                    <div
                      v-for="item in items"
                      :data-isleaf="item.isLeaf"
                      :data-id="item.node.id"
                      :key="item.node.key"
                      :data-role="item.isLeaf ? 'item' : 'group'"
                      class="contact-tree-body-list-holder-inner-item"
                    >
                      <div
                        class="contact-tree-body-list-holder-inner-item-left"
                      >
                        <template v-if="item.isLeaf">
                          <span></span>
                          <div class="name-color-container">
                            <div
                              :style="{
                                'background-color': randFirstNameColor(
                                  item.node.name
                                )
                              }"
                              class="name-color"
                            >
                              {{ item.node.name.charAt(0) }}
                            </div>
                          </div>
                          <div
                            class="name-container contact-tree-body-list-holder-inner-item-left-name-overflow"
                          >
                            <div
                              :title="item.node.name"
                              class="item-name item-text"
                            >
                              {{ item.node.name }}
                            </div>

                            <div
                              :title="buildShowPhone(item.node)"
                              class="item-text"
                            >
                              {{ buildShowPhone(item.node) }}
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <span :class="{ open: item.isOpen }">
                            <a-icon
                              class="caret"
                              v-if="!item.isEmpty"
                              :type="item.isLoading ? 'loading' : 'caret-right'"
                            />
                          </span>
                          <span>
                            <img
                              class="contact-tree-file-img"
                              src="@/assets/images/file.png"
                            />
                          </span>
                          <div
                            class="contact-tree-body-list-holder-inner-item-left-name-overflow"
                            :title="item.node.name"
                          >
                            {{ item.node.name }}({{ item.node.num }})
                          </div>
                        </template>
                      </div>
                      <div
                        class="contact-tree-body-list-holder-inner-item-right"
                      >
                        <template v-if="item.isLeaf">
                          <span
                            :data-id="item.node.id"
                            :class="{
                              check: item.isCheck || item.isDisabled,
                              disabled: item.isDisabled
                            }"
                          >
                          </span>
                        </template>
                        <template v-else>
                          <span
                            data-role="group-check"
                            :data-id="item.node.id"
                            :class="{
                              check: item.isCheck
                            }"
                          >
                          </span>
                        </template>
                      </div>
                    </div>
                  </VirtualList>
                </div>
              </div>
            </div>
          </div>
          <div class="contact-choice-list">
            <div class="contact-choice-count">
              已选({{ this.newSelectTotalNumber }})
            </div>
            <div class="contact-choice-item">
              <template v-for="node in newSelect">
                <div :key="node.key">
                  <template v-if="isNewSelectAddress(node.type)">
                    <span>
                      <div
                        class="contact-choice-item-address-first"
                        :style="{
                          'background-color': randFirstNameColor(node.name)
                        }"
                      >
                        {{ node.name.charAt(0) }}
                      </div>
                      <div class="new-select-address">
                        <span
                          :title="node.name"
                          class="new-select-address-name"
                        >
                          {{ node.name }}
                        </span>
                        <span
                          :title="node.phone"
                          class="new-select-address-phone"
                        >
                          {{ node.phone }}
                        </span>
                      </div>
                    </span>
                  </template>
                  <template v-else-if="isNewSelectGroup(node.type)">
                    <svg-icon
                      class="search-result-item-group-icon"
                      icon-class="group"
                    />
                    <span :title="node.name" class="new-select-node">
                      {{ node.name }} {{ node.num }}
                    </span>
                  </template>
                  <svg-icon
                    class="contact-choice-item-close-icon"
                    @click="handleNewSelectClose(node)"
                    icon-class="light-close"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>

        <template slot="footer">
          <div>
            <a-button
              key="back"
              class="add-button"
              :disabled="addDisable"
              :loading="addLoading"
              @click="handleAdd"
            >
              添加至参会列表
            </a-button>
            <a-button
              key="submit"
              :disabled="callDisable"
              :loading="callLoading"
              @click="handleCall"
              type="primary"
            >
              立即外呼
            </a-button>
          </div>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
// import { queryAddressModel } from "@/services/address";

/**
 *  需要安装antd和lodash
 *  props
 *    visible: 显示通讯录对话框
 *    searchData: 搜索接口，要返回联系人数据和组数据
 *                  (searchKey, page, pageSize) => {} 需要返回Promise
 *                    返回数据结构 [{
 *                                addressList: [{id, groupId, name, phone, email, countryCode, areaCode}],
 *                                groupList: [{id, name, num, parentId}],
 *                                }]
 *    getAllGroup: 获取所有组数据接口
 *                    () => {}
 *                返回数据结构 [{id, name, num, parentId}] num是该组下所有联系人数，包括子组的联系人
 *
 *    getGroupAddress: 获取多个组的联系人接口
 *                (groulIdList, type) => {}
 *                  groulIdList 是组id列表， type: 1 不搜索子组联系人，2 搜索子组联系人
 *                返回数据结构  [{id, groupId, name, phone, email, countryCode, areaCode}]
 *
 *  事件
 *    cancel: 关闭通讯录对话框，需要修改visible为false
 *    ok: 确认添加联系人，返回新增联系人数据 [{countryCode, areaCode,phone, name, email }]
 */

import { debounce } from "lodash";
import { spliceTelNumberKey } from "@/utils/validator";

// import Tree from "@/components/tree";

const NEW_SELECT_TYPE_ADDRESS = "NEW_SELECT_TYPE_ADDRESS";
const NEW_SELECT_TYPE_GROUP = "NEW_SELECT_TYPE_GROUP";

// import VirtualList from "@/components/virtualList";
import VirtualList from "vue-virtualization-list";

export default {
  components: {
    VirtualList
  },
  props: {
    visible: {
      require: true,
      type: Boolean
    },
    searchData: {
      require: true,
      type: Function
    },
    getAllGroup: {
      require: true,
      type: Function
    },
    getGroupAddress: {
      require: true,
      type: Function
    }
  },
  beforeCreate() {
    this.addressList = []; // 地址数据，数据量较大，不做响应式
  },

  data() {
    return {
      callLoading: false,
      addLoading: false,
      searchText: "",
      showSearchLoading: false,
      showSearchResult: false, // 显示搜索结果
      checkedKeys: [], // tree中的勾选数据
      checkedDisableKeys: [], // tree中的disable数据
      groupList: [
        {
          id: -1,
          name: "未分组",
          num: 0,
          parentId: -1,
          key: "group--1"
        }
      ], // 组数据
      addressUpdateFlag: 0,
      searchResult: {
        empty: true,
        address: [],
        group: []
      }, // 搜索数据
      newSelect: [
        // type: 1 通讯录选择，info : { type: group|address, id: int, name: string }
      ], // 新增选择数据
      expandedKeys: [],
      loadedKeys: [],
      loadingKeys: []
    };
  },
  computed: {
    emptyGroupList() {
      const emptyGroupList = {};
      this.loadedKeys.forEach(key => {
        if (undefined === this.addressRelationList[key]) {
          emptyGroupList[key] = true;
        }
      });
      return emptyGroupList;
    },
    expandedKeysList() {
      const expandedKeys = {};
      this.expandedKeys.forEach((key, index) => {
        expandedKeys[key] = index;
      });
      return expandedKeys;
    },
    loadedKeysList() {
      const loadedKeysList = {};
      this.loadedKeys.forEach((key, index) => {
        loadedKeysList[key] = index;
      });

      return loadedKeysList;
    },
    loadingKeysList() {
      const loadingKeysList = {};
      this.loadingKeys.forEach((key, index) => {
        loadingKeysList[key] = index;
      });

      return loadingKeysList;
    },
    checkedKeysList() {
      const checkedKeysList = {};
      this.checkedKeys.forEach((key, index) => {
        checkedKeysList[key] = index;
      });
      return checkedKeysList;
    },
    addDisable() {
      return this.callLoading;
    },
    callDisable() {
      return this.addLoading;
    },
    newSelectTotalNumber() {
      let newSelectTotalNumber = 0;
      this.newSelect.forEach(select => {
        if (this.isNewSelectGroup(select.type)) {
          newSelectTotalNumber += select.num;
        } else if (this.isNewSelectAddress(select.type)) {
          newSelectTotalNumber++;
        }
      });
      return newSelectTotalNumber;
      //return this.newSelect.length;
    },
    searchResultAddressRelationList() {
      const searchResultAddressRelationList = this.searchResult.address.map(
        address => {
          // 首先查看是否在已选中
          //    如果在已选中就将其checked并且disabled
          address.checked = false;
          address.disabled = false;
          address.showPhone = this.buildShowPhone(address);
          address.firstNameColor = this.randFirstNameColor(address.name);

          // 或者查看其是否在新增中
          //  如果在新增中就将其checked
          if (this.findAddressInNewSelect(address)) {
            address.checked = true;
          }

          // 检查父级节点
          let group = this.newSelect.filter(item => {
            return (
              this.isNewSelectGroup(item.type) && item.id === address.groupId
            );
          });
          if (group.length > 0) {
            address.checked = true;
            address.disabled = true;
          }
          return address;
        }
      );

      return searchResultAddressRelationList;
    },
    searchResultGroupRelationList() {
      const searchResultGroupRelationList = this.searchResult.group.map(
        group => {
          if (this.findGroupInNewSelect(group)) {
            group.checked = true;
          } else {
            group.checked = false;
          }
          return group;
        }
      );
      return searchResultGroupRelationList;
    },
    treeCheckedDisableList() {
      const treeCheckedDisableList = {};
      this.checkedDisableKeys.forEach(key => {
        treeCheckedDisableList[key] = true;
      });
      return treeCheckedDisableList;
    },
    visibleModal: {
      get: function() {
        return this.visible;
      },
      set: function() {}
    },
    addressRelationList() {
      const addressList = {};
      if (this.addressUpdateFlag >= 0) {
        this.addressList.forEach(address => {
          if (!Array.isArray(addressList[address.groupId])) {
            addressList[address.groupId] = [];
          }
          // 验证是否disable
          const key = this.buildAddressKey(address.id);
          if (this.treeCheckedDisableList[key]) {
            address.disabled = true;
          } else {
            address.disabled = false;
          }
          address.key = key;
          addressList[address.groupId].push(address);
        });
      }
      return addressList;
    },
    addressIdObjectList() {
      const addressIdObjectList = {};
      if (this.addressUpdateFlag >= 0) {
        this.addressList.forEach(address => {
          addressIdObjectList[address.id] = address;
        });
      }
      return addressIdObjectList;
    },
    groupRelationList() {
      const groupList = {};
      this.groupList.forEach(group => {
        if (!Array.isArray(groupList[group.parentId])) {
          groupList[group.parentId] = [];
        }
        group.key = this.buildGroupKey(group.id);
        if (this.treeCheckedDisableList[group.key]) {
          group.disabled = true;
        } else {
          group.disabled = false;
        }
        // 验证是否disable
        groupList[group.parentId].push(group);
      });
      return groupList;
    },
    groupIdObjectList() {
      const groupIdObjectList = {};
      this.groupList.forEach(group => {
        groupIdObjectList[group.id] = group;
      });
      return groupIdObjectList;
    },
    treeOrderList() {
      const treeOrderList = [];
      this.groupList.forEach(group => {
        const isOpen = undefined !== this.expandedKeysList[group.id];
        const isGroupCheck = undefined !== this.checkedKeysList[group.key];
        const isLoading = undefined !== this.loadingKeysList[group.id];
        const isEmpty = !!this.emptyGroupList[group.id];
        treeOrderList.push({
          isLeaf: 0,
          isOpen,
          isCheck: isGroupCheck,
          node: group,
          isLoading,
          isEmpty
        });
        if (isOpen) {
          const itemList = this.addressRelationList[group.id];
          if (Array.isArray(itemList) && itemList.length > 0) {
            itemList.forEach(address => {
              const isDisabled = address.disabled;
              const isCheck = undefined !== this.checkedKeysList[address.key];
              treeOrderList.push({
                isLeaf: 1,
                node: address,
                isDisabled,
                isCheck
              });
            });
          }
        }
      });
      return treeOrderList;
    },
    newSelectRelationList() {
      // 新选择项的map格式数据
      const newSelectRelationList = {};

      this.newSelect.forEach((select, index) => {
        const key = this.buildNewSelectKey(select);
        newSelectRelationList[key] = index;
      });

      return newSelectRelationList;
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.callLoading = false;
        this.addLoading = false;
        this.getAllGropuInfo();
        this.queryGroupAddress(-1, () => {});
      } else {
        this.clearData();
      }
      // 初始化数据
    }
  },
  mounted() {
    this.handleCallError();
  },
  methods: {
    updateAddressFlag() {
      this.addressUpdateFlag = Math.random();
    },
    bindClickTree(e) {
      let target = e.target;
      while (!target.dataset || !target.dataset.role) {
        target = target.parentNode;
      }
      const id = parseInt(target.dataset.id);
      if ("group" === target.dataset.role) {
        this.clickTreeGroup(id);
      } else if ("group-check" === target.dataset.role) {
        this.clickTreeGroupCheck(id);
      } else if ("item" === target.dataset.role) {
        this.clickTreeItem(id);
      }
    },
    clickTreeGroup(id) {
      const index = this.expandedKeysList[id];
      if (undefined !== index) {
        this.expandedKeys.splice(index, 1);
      } else {
        const isLoad = this.loadedKeysList[id];

        if (undefined !== isLoad) {
          this.expandedKeys.push(id);
        } else {
          this.loadingKeys.push(id);
          const index = this.loadedKeysList[id];
          this.onLoadData(id)
            .then(() => {
              this.loadedKeys.push(id);
              this.expandedKeys.push(id);
              this.loadingKeys.splice(index, 1);
            })
            .catch(() => {
              this.loadingKeys.splice(index, 1);
            });
        }
      }
    },
    clickTreeGroupCheck(id) {
      const group = this.groupIdObjectList[id];

      if (group) {
        const key = group.key;
        const index = this.checkedKeysList[key];
        const info = {
          id,
          isLeaf: undefined,
          checked: true
        };
        if (undefined !== index) {
          info.checked = false;
          // 组item全部取消选中
        } else {
          // 组item全部选中
        }
        this.handleTreeCheck(info);
      }
    },
    clickTreeItem(id) {
      // 如果组已经选中，则不做处理
      const item = this.addressIdObjectList[id];
      if (item) {
        const group = this.groupIdObjectList[item.groupId];

        const isGroupCheck = undefined !== this.checkedKeysList[group.key];

        if (!isGroupCheck) {
          const key = item.key;
          const index = this.checkedKeysList[key];
          const info = {
            id,
            isLeaf: true,
            checked: true
          };
          if (undefined !== index) {
            info.checked = false;
            // 对应组如果选中，则取消选中，
          }
          this.handleTreeCheck(info);
        }
      }
    },
    handleCallError() {
      this.$on("contact-model-call-error", () => {
        this.callLoading = false;
        this.addLoading = false;
      });
    },
    clearData() {
      // 清空新增成员
      // 清空tree
      // 清空search
      this.checkedKeys.splice(0, this.checkedKeys.length); // 清空勾选
      this.checkedDisableKeys.splice(0, this.checkedDisableKeys.length); // 清空disable
      this.loadedKeys.splice(1, this.loadedKeys.length - 1); // loadedKeys 留下root
      this.addressList.splice(0, this.addressList.length); // 清空address

      this.newSelect.splice(0, this.newSelect.length); // 清空新增

      this.searchResult.address.splice(0, this.searchResult.address.length);
      this.searchResult.group.splice(0, this.searchResult.group.length);
      this.searchText = "";
      this.showSearchResult = false;

      this.expandedKeys.splice(0, this.expandedKeys.length); // 清空勾选
      this.loadedKeys.splice(0, this.loadedKeys.length); // 清空勾选
      this.loadingKeys.splice(0, this.loadingKeys.length); // 清空勾选
      // this.$refs.virtualTreeInner.scrollTop = 0;
    },
    buildNewSelectAddressNode(address) {
      //console.log(address);
      const showPhone = this.buildShowPhone(address);
      return {
        type: NEW_SELECT_TYPE_ADDRESS,
        id: address.id,
        name: address.name,
        phone: showPhone,
        groupId: address.groupId,
        key: `${NEW_SELECT_TYPE_ADDRESS}-${address.id}`
      };
    },
    buildNewSelectGroupNode(group) {
      return {
        type: NEW_SELECT_TYPE_GROUP,
        id: group.id,
        name: group.name,
        num: group.num,
        key: `${NEW_SELECT_TYPE_GROUP}-${group.id}`
      };
    },
    isNewSelectAddress(type) {
      return type === NEW_SELECT_TYPE_ADDRESS;
    },
    isNewSelectGroup(type) {
      return type === NEW_SELECT_TYPE_GROUP;
    },
    addAddressToNewSelect(address) {
      const addressNode = this.buildNewSelectAddressNode(address);
      this.addNodeToNewSelect(addressNode);
    },
    deleteAddressFromNewSelect(address) {
      const addressNode = this.buildNewSelectAddressNode(address);
      this.deleteNodeFromNewSelect(addressNode);
    },
    addGroupToNewSelect(group) {
      const groupNode = this.buildNewSelectGroupNode(group);
      this.addNodeToNewSelect(groupNode);
    },
    deleteGroupFromNewSelect(group) {
      const groupNode = this.buildNewSelectGroupNode(group);
      this.deleteNodeFromNewSelect(groupNode);
    },
    addNodeToNewSelect(node) {
      // 检查node是否有重复，因为百应同一个联系人可以存在多个组内，所以需要检查是否已经选中
      if (!this.isNodeInNewSelect(node)) {
        this.newSelect.push(node);

        // 选择人，检查所在分组
        if (this.isNewSelectAddress(node.type)) {
          // let selectGroup = this.groupList.filter(item => {
          //   return item.id === node.groupId;
          // });
          let selectGroup = this.groupRelationList[node.groupId];
          //console.log('selectGroup',selectGroup)
          if (selectGroup) {
            let groupUser = this.newSelect.filter(item => {
              return (
                this.isNewSelectAddress(item.type) &&
                item.groupId === selectGroup.id
              );
            });
            if (selectGroup.num === groupUser.length) {
              this.addGroupToCheckedKeys(selectGroup.id);

              let exitNode = this.newSelect.filter(item => {
                return (
                  this.isNewSelectGroup(item.type) && item.id === selectGroup.id
                );
              });
              if (exitNode.length === 0) {
                this.newSelect.push(this.buildNewSelectGroupNode(selectGroup));
              }
              // 取消已选择的组下的人
              groupUser.forEach(item => {
                this.deleteNodeFromNewSelect(item);
                this.addAddressToCheckedDisableKeys(item.id);
              });
            }
          }
        } else {
          // 选择组，检查已经选择组下的人
          let groupUser = this.newSelect.filter(item => {
            return (
              this.isNewSelectAddress(item.type) && item.groupId === node.id
            );
          });
          groupUser.forEach(item => {
            this.deleteNodeFromNewSelect(item);
          });
        }
        //console.log('select node', node)
      }
    },
    deleteNodeFromNewSelect(node) {
      const findKey = this.findNodeInNewSelect(node);
      if (findKey !== -1) {
        this.newSelect.splice(findKey, 1);
      }
    },
    isNodeInNewSelect(node) {
      return this.findNodeInNewSelect(node) !== -1;
    },
    findNodeInNewSelect(node) {
      const key = this.buildNewSelectKey(node);

      const findIndex = this.newSelectRelationList[key];
      return findIndex >= 0 ? findIndex : -1;
    },
    findAddressInNewSelect(address) {
      const addressNode = this.buildNewSelectAddressNode(address);
      return this.isNodeInNewSelect(addressNode);
    },
    findGroupInNewSelect(group) {
      const groupNode = this.buildNewSelectGroupNode(group);
      return this.isNodeInNewSelect(groupNode);
    },
    matchSelected(phone) {
      // 通过国家，区号，电话匹配已选数据
      if (this.selectedRelationList[phone]) {
        return true;
      }
      return false;
    },
    addressMatchSelected(address) {
      if (this.selectedRelationList[address.phone]) {
        return true;
      }
      return false;
    },
    buildGroupKey(id) {
      return "group-" + id;
    },
    buildAddressKey(id) {
      return id;
    },
    getAllGropuInfo() {
      if (this.groupList.length === 1) {
        this.getAllGroup().then(data => {
          if (Array.isArray(data)) {
            data.forEach(group => {
              group.key = this.buildGroupKey(group.id);
              this.groupList.push(group);
            });
          }
        });
      }
    },
    isKeyInCheckedDisableKeys(key) {
      return this.checkedDisableKeys.indexOf(key) !== -1;
    },
    findCheckedDisableKeys(key) {
      return this.checkedDisableKeys.indexOf(key);
    },
    addCheckedDisableKeys(key) {
      if (!this.isKeyInCheckedDisableKeys(key)) {
        this.checkedDisableKeys.push(key);
      }
    },
    deleteCheckedDisableKeys(key) {
      const findKey = this.findCheckedDisableKeys(key);
      if (findKey !== -1) {
        this.checkedDisableKeys.splice(findKey, 1);
      }
    },
    isKeyInCheckedKeys(key) {
      return this.checkedKeys.indexOf(key) !== -1;
    },
    findCheckedKeys(key) {
      return this.checkedKeys.indexOf(key);
    },
    addCheckedKeys(key) {
      if (!this.isKeyInCheckedKeys(key)) {
        this.checkedKeys.push(key);
      }
    },
    deleteCheckedKeys(key) {
      const findKey = this.findCheckedKeys(key);
      if (findKey !== -1) {
        this.checkedKeys.splice(findKey, 1);
      }
    },
    isGroupInCheckedKeys(id) {
      const key = this.buildGroupKey(id);
      return this.isKeyInCheckedKeys(key);
    },
    isAddressInCheckedKeys(id) {
      const key = this.buildAddressKey(id);
      return this.isKeyInCheckedKeys(key);
    },
    addGroupToCheckedKeys(id) {
      const key = this.buildGroupKey(id);
      this.addCheckedKeys(key);
    },
    deleteGroupFromCheckedKeys(id) {
      const key = this.buildGroupKey(id);
      this.deleteCheckedKeys(key);
    },
    addAddressToCheckedKeys(id) {
      const key = this.buildAddressKey(id);
      this.addCheckedKeys(key);
    },
    deleteAddressFromCheckedKeys(id) {
      const key = this.buildAddressKey(id);
      this.deleteCheckedKeys(key);
    },
    addGroupToCheckedDisableKeys(id) {
      const key = this.buildGroupKey(id);
      this.addCheckedDisableKeys(key);
    },
    deleteGroupFromCheckedDisableKeys(id) {
      const key = this.buildGroupKey(id);
      this.deleteCheckedDisableKeys(key);
    },
    addAddressToCheckedDisableKeys(id) {
      const key = this.buildAddressKey(id);
      this.addCheckedDisableKeys(key);
    },
    deleteAddressFromCheckedDisableKeys(id) {
      const key = this.buildAddressKey(id);
      this.deleteCheckedDisableKeys(key);
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async submit(cb) {
      const newSelectAddress = await this.getNewSelectAddressList();

      // 过滤
      const addressList = [];
      // spliceTelNumberKey
      const spliceNumberList = {};
      newSelectAddress.forEach(address => {
        const spliceNumber = spliceTelNumberKey(
          address.countryCode,
          address.areaCode,
          address.phone
        );
        if (!spliceNumberList[spliceNumber]) {
          // 号码去重
          spliceNumberList[spliceNumber] = true;
          addressList.push({
            countryCode: address.countryCode,
            areaCode: address.areaCode,
            phone: address.phone,
            name: address.name,
            email: address.email,
            role: address.role,
            company: address.depName,
            department: address.department
          });
        }
      });
      if (addressList.length > 0) {
        //console.log('select addressList',addressList)
        cb(addressList);
        this.$emit("ok", addressList);
      } else {
        this.$message.info("请选择参会人");
      }
    },
    async handleAdd() {
      await this.submit(addressList => {
        this.addLoading = true;
        this.$emit("add", addressList);
      });
    },
    async handleCall() {
      // 从新增数据过滤
      // 获取group，获取address
      // const newSelectAddress = await this.getNewSelectAddressList();

      await this.submit(addressList => {
        this.callLoading = true;
        this.$emit("call", addressList);
      });
    },
    handleTreeCheck(event) {
      // 获取key
      const nodeId = event.id;
      if (event.checked) {
        // 将key 推入 this.checkedKeys
        if (this.isTreeAddressNode(event)) {
          // 判断是否是address
          this.treeAddressChecked(nodeId);
        } else if (this.isTreeGroupNode(event)) {
          // 判断是否是group
          this.treeGroupChecked(nodeId);
        }
      } else {
        // 将key 弹出 this.checkedKeys
        if (this.isTreeAddressNode(event)) {
          // 判断是否是address
          this.treeAddressUnChecked(nodeId);
        } else if (this.isTreeGroupNode(event)) {
          // 判断是否是group
          this.treeGroupUnChecked(nodeId);
        }
      }
    },
    treeGroupChecked(id, isAddNewSelect = true) {
      // 该组加入 checkedKeys
      // 对该组的联系人进行过滤，存在于已选的跳过操作
      const group = this.groupIdObjectList[id];
      if (group) {
        this.addGroupToCheckedKeys(id);
        if (isAddNewSelect) {
          this.addGroupToNewSelect(group);
        }
      }

      const groupAddressList = this.addressRelationList[id];
      if (groupAddressList) {
        // address加入checked和disabled
        groupAddressList.forEach(address => {
          this.addAddressToCheckedKeys(address.id);
          this.addAddressToCheckedDisableKeys(address.id);
        });
      }
    },
    treeAddressChecked(id, isAddNewSelect = true) {
      // 如果该数据存在于已选数据，则跳过剩余操作
      // 该联系人加入checkedKeys
      // 新增成员 添加 address节点
      const address = this.addressIdObjectList[id];
      if (address) {
        this.addAddressToCheckedKeys(id);
        if (isAddNewSelect) {
          this.addAddressToNewSelect(address);
        }
      }
    },
    treeGroupUnChecked(id, isDeleteNewSelect = true) {
      // 检查该组和组下联系人
      // 如果该节点是disabled就跳过删除

      const group = this.groupIdObjectList[id];
      if (group && !group.disabled) {
        // 从新增删除该组
        this.deleteGroupFromCheckedKeys(id);
        if (isDeleteNewSelect) {
          this.deleteGroupFromNewSelect(group);
        }

        // 处理address
        // 如果存在已选则不处理address
        const groupAddressList = this.addressRelationList[id];
        if (groupAddressList) {
          // address加入checked和disabled
          groupAddressList.forEach(address => {
            // 如果不在已选中
            this.deleteAddressFromCheckedKeys(address.id);
            this.deleteAddressFromCheckedDisableKeys(address.id);
            this.deleteAddressFromNewSelect(address);
          });
        }

        const groupStack = [];
        const subGroup = this.groupRelationList[id];
        if (subGroup) {
          subGroup.forEach(group => {
            groupStack.push(group);
          });
        }
        while (groupStack.length > 0) {
          //
          const group = groupStack.pop();
          const groupId = group.id;
          // group 加入checked和disabled
          this.deleteGroupFromCheckedKeys(groupId);
          this.deleteGroupFromCheckedDisableKeys(groupId);
          this.deleteGroupFromNewSelect(group);
          // 获取子
          const groupAddressList = this.addressRelationList[groupId];
          if (groupAddressList) {
            // address加入checked和disabled
            groupAddressList.forEach(address => {
              this.deleteAddressFromCheckedKeys(address.id);
              this.deleteAddressFromCheckedDisableKeys(address.id);
              this.deleteAddressFromNewSelect(address);
            });
          }
          // 获取子组 推入groupStack
          const subGroup = this.groupRelationList[groupId];
          if (subGroup) {
            subGroup.forEach(group => {
              groupStack.push(group.id);
            });
          }
        }
      }
    },
    treeAddressUnChecked(id, isDeleteNewSelect = true) {
      // 该联系人从checkedKeys删除
      // 新增成员 删除address节点

      // 如果该节点是disabled 跳过删除
      const address = this.addressIdObjectList[id];
      if (address && !address.disabled) {
        this.deleteAddressFromCheckedKeys(id);
        if (isDeleteNewSelect) {
          this.deleteAddressFromNewSelect(address);
        }
      }
    },
    isTreeGroupNode(node) {
      return node.isLeaf === undefined;
    },
    isTreeAddressNode(node) {
      return node.isLeaf === true;
    },
    onLoadData(id) {
      return new Promise(resolve => {
        if (id) {
          this.queryGroupAddress(id, resolve);
        } else {
          resolve();
        }
      });
    },
    queryGroupAddress(groupId, callback, type = 1) {
      const key = this.buildGroupKey(groupId);
      this.getGroupAddress([groupId], type)
        .then(data => {
          console.log("getGroupAddress");
          console.log(data);
          this.loadedKeys.push(key);
          data.forEach(address => {
            this.addAddressList(address);
          });
          this.updateAddressFlag();
          if (-1 === groupId && data.length > 0) {
            this.groupList[0].num = data.length;
          }
          // 检查组是否已check,如果check将address加入this.checkKeys
          if (this.isGroupInCheckedKeys(groupId)) {
            data.forEach(address => {
              this.addAddressToCheckedKeys(address.id);
              this.addAddressToCheckedDisableKeys(address.id);
            });
          } else {
            // data.forEach(address => {
            //   // 检查该数据是否是已选的，如果数据是已选的加入 this,checkKeys
            //   if (this.addressMatchSelected(address)) {
            //     this.addAddressToCheckedKeys(address.id);
            //     this.addAddressToCheckedDisableKeys(address.id);
            //   }
            // });
          }
          callback();
        })
        .catch(e => {
          console.log(e);
          callback();
        });
    },
    addAddressList(address) {
      const findAddress = this.addressIdObjectList[address.id];
      if (!findAddress || findAddress.groupId !== address.groupId) {
        // 百应联系人可以在多个组内重复 所以要注释这个检查
        address.disabled = false;
        this.addressList.push(address);
      }
    },
    handleNewSelectClose(node) {
      // 删除search相关节点checked
      this.deleteNodeFromNewSelect(node); // 从新增数据删除该节点
      if (this.isNewSelectAddress(node.type)) {
        // tree 删除address节点勾选
        this.treeAddressUnChecked(node.id, false);
        // search 删除address节点勾选
        this.searchAddressUnChecked(node.id);
      } else if (this.isNewSelectGroup(node.type)) {
        // tree 删除group节点勾选
        this.treeGroupUnChecked(node.id, false);
        // search 删除group节点勾选
        this.searchGroupUnChecked(node.id);
      }
    },
    handleSearchChange() {
      this.search();
    },
    handleSearchKeypressEnter(e) {
      if (e.key === "Enter") {
        this.search();
      }
    },
    clearSearchResult() {
      this.searchResult.empty = false;
      this.searchResult.address.splice(0, this.searchResult.address.length);
      this.searchResult.group.splice(0, this.searchResult.group.length);
    },
    search: debounce(function() {
      if (this.searchText !== "") {
        this.showSearchResult = true;
        this.showSearchLoading = true;
        this.clearSearchResult();
        this.searchData(this.searchText, 1, 100).then(result => {
          result.addressList.forEach(address => {
            this.addAddressList({ ...address });
            address.checked = false;
            const findIndex = this.searchResult.address.findIndex(node => {
              return node.id === address.id;
            });
            if (-1 === findIndex) {
              this.searchResult.address.push(address);
            }
          });
          this.updateAddressFlag();
          if (
            (result &&
              Array.isArray(result.addressList) &&
              result.addressList.length > 0) ||
            this.searchResult.group.length > 0
          ) {
            this.searchResult.empty = false;
          } else {
            this.searchResult.empty = true;
          }
          // this.addAddressToDataList(result);
          this.showSearchLoading = false;
        });

        // 搜索组信息
        // 全部组都已经下载到本地
        // 使用正则匹配
        const re = new RegExp(this.searchText);
        const filterGroup = this.groupList.filter(group => {
          if (re.exec(group.name) !== null) {
            return true;
          }
          return false;
        });
        if (filterGroup) {
          this.searchResult.group.push(...filterGroup);
        }
      } else {
        this.showSearchResult = false;
      }
    }, 300),
    handleSearchAddressCheckboxClick(address) {
      address.checked = !address.checked;
      if (address.checked) {
        // 勾选，同步添加新增成员
        this.addAddressToNewSelect(address);
        this.treeAddressChecked(address.id, false);
      } else {
        // 取消勾选， 同步新增成员 删除
        this.deleteAddressFromNewSelect(address);
        this.treeAddressUnChecked(address.id, false);
      }
    },
    handleSearchGroupCheckboxClick(group) {
      group.checked = !group.checked;
      if (group.checked) {
        // 勾选，同步添加新增成员
        this.addGroupToNewSelect(group);
        this.treeGroupChecked(group.id, false);
      } else {
        // 取消勾选， 同步新增成员 删除
        this.deleteGroupFromNewSelect(group);
        this.treeGroupUnChecked(group.id, false);
      }
    },
    searchAddressUnChecked(id) {
      const address = this.findSearchAddress(id);
      if (address && !address.disabled) {
        address.checked = false;
      }
    },
    searchGroupUnChecked(id) {
      const group = this.findSearchGroup(id);
      if (group) {
        group.checked = false;
      }
    },
    findSearchAddress(id) {
      return this.searchResult.address.find(address => address.id === id);
    },
    findSearchGroup(id) {
      return this.searchResult.group.find(group => group.id === id);
    },
    async getNewSelectAddressList() {
      const addressIdList = [];
      const newSelectAddressIdObjectList = {};
      const groupIdList = [];

      this.newSelect.forEach(node => {
        if (this.isNewSelectAddress(node.type)) {
          addressIdList.push(node.id);
          newSelectAddressIdObjectList[node.id] = true;
        } else if (this.isNewSelectGroup(node.type)) {
          groupIdList.push(node.id);
        }
      });
      // 获取新增的address
      const newSelectAddressList = [];
      addressIdList.forEach(addressId => {
        const address = this.addressIdObjectList[addressId];
        if (address) {
          newSelectAddressList.push(address);
        }
      });

      // groupId 去重，如果父id已选，则去掉该groupId
      if (groupIdList.length > 0) {
        const selectGroupIdList = {};

        // 将查到的组的所有子组都放入selectGroupIdList
        // 如果groupIdList内组id存在于selectGroupIdList 则删除该组id

        groupIdList.forEach(groupId => {
          selectGroupIdList[groupId] = true;
          // 获取该组下的子组
        });

        const searchGroupIdList = [];

        groupIdList.forEach(groupId => {
          // 查看组的父组或父组的父组是否存在，不存在就查询该组，存在就不查寻该组
          const group = this.groupIdObjectList[groupId];
          let findParentId = group.parentId;
          let addGroup = true;
          while (findParentId > 0) {
            if (selectGroupIdList[findParentId]) {
              addGroup = false;
              break;
            }
            const group = this.groupIdObjectList[findParentId];
            findParentId = group.parentId;
          }
          if (addGroup) {
            searchGroupIdList.push(groupId);
          }
        });
        try {
          const result = await this.getGroupAddress(searchGroupIdList, 2);

          if (result) {
            result.forEach(address => {
              // 检查该address是否是已选数据
              // 检查该address是否已添加
              if (newSelectAddressIdObjectList[address.id]) {
                return;
              }
              newSelectAddressList.push(address);
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
      return newSelectAddressList;
    },
    randFirstNameColor: (function() {
      const colorList = ["#01b896", "#6297fe", "#fe9162"];
      const firstNameCodeList = {};
      return function(name) {
        const firstNameCode = name.charCodeAt(0);
        if (!firstNameCodeList[firstNameCode]) {
          firstNameCodeList[firstNameCode] = firstNameCode % 3;
        }
        return colorList[firstNameCodeList[firstNameCode]];
      };
    })(),
    buildNewSelectKey(select) {
      return select.type + "-" + select.id;
    },
    buildShowPhone(address) {
      return (
        (address.countryCode ? `(${address.countryCode})` : "") +
        (address.areaCode ? `${address.areaCode}-` : "") +
        address.phone
      );
    }
  }
};
</script>

<style lang="less">
.contact-modal {
  .ant-modal-content {
    width: 680px;
    height: 560px;
    position: relative;
    text-align: center;
  }
  .ant-modal-title {
    text-align: center;
  }

  .ant-modal-footer {
    width: 100%;
    height: 63px;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
    add-button {
      background: #fff;
      border: solid 1px #e5e5e5;
      // border-radius: 0;
      font-size: 13px;
      height: 32px;
      color: #333333;

      &:focus {
        outline: none;
        color: #333333;
        border-color: #e5e5e5;
      }

      &:after {
        border: 0 none;
        opacity: 0;
        animation: none 0 ease 0 1 normal;
      }

      &:hover {
        outline: none;
        border: solid 1px rgba(0, 0, 0, 0.4);
        background-color: rgba(255, 255, 255, 0.8);
        color: #333333;
      }

      &:active {
        color: #333333;
        border: solid 1px rgba(0, 0, 0, 0.4);
        background-color: rgba(0, 0, 0, 0.3);
      }

      &:disabled {
        border-color: #d9d9d9 !important;
        color: rgba(0, 0, 0, 0.25) !important;
        background-color: #f5f5f5 !important;
        text-shadow: none !important;
        box-shadow: none !important;
      }
    }
  }

  .ant-btn {
    min-width: 80px;
    height: 32px;
  }

  .ant-modal-body {
    padding: 0 !important;
  }

  .contact-tree-leaf-first-name {
    position: absolute;
    left: -6px;
    width: 28px;
    height: 28px;
    line-height: 28px;
    border-radius: 50%;
    font-size: 12px;
    color: #ffffff;
    margin-right: 10px;
  }

  .contact-tree-leaf-title {
    display: flex;
    //flex-direction: column;
    height: 28px;
    span {
      font-size: 13px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      line-height: 28px;
    }
    span:first-child {
      padding-left: 6px;
      min-width: 60px;
    }
    span:last-child {
      //padding-left: 10px;
    }
  }

  .contact-modal-content {
    display: flex;
    height: 442px;
  }

  .contact-tree-contanier {
    width: 400px;
    border-right: 1px solid #d7d7d7;
    height: 100%;
    /* padding: 0 20px; */
  }

  .contact-tree-search {
    margin: 16px 0;
    position: relative;
    padding: 0 12px;
    display: flex;
    align-items: center;
  }

  .contact-tree-search-input {
    // width: 325px;
    margin-right: 11px;
    .ant-input-lg {
      text-align: left;
    }
  }

  .contact-tree-search-quick-invite {
    width: 32px;
    height: 32px;
    border: solid 1px rgba(0, 0, 0, 0.12);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    svg {
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }
  }

  .search-result-show {
    display: block !important;
  }

  .search-result-show {
    display: block;
  }

  .search-result {
    display: none;
    position: absolute;
    top: 43px;
    left: 12px;
    width: 360px;
    height: auto;
    max-height: 368px;
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    border: solid 1px #d7d7d7;
    background-color: #ffffff;
    z-index: 10;
  }

  .search-spin {
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .contact-choice-empty-search {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 58px 0;
  }

  .contact-choice-empty-search-icon {
    width: 160px !important;
    height: 120px !important;
  }

  .search-result-item-container {
    margin-top: 8px;
  }

  .search-result-address-container {
    max-height: 176px;
  }

  .search-result-container-header {
    height: 32px;
    background-color: rgba(0, 0, 0, 0.04);
    line-height: 32px;
    text-align: left;
    padding-left: 20px;
  }

  .search-result-container-header span {
    opacity: 0.5;
    font-size: 12px;
    color: #000000;
  }

  .search-result-item-group-icon {
    width: 28px !important;
    height: 28px !important;
    margin-right: 10px;
  }

  .search-result-item {
    height: 48px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
  }

  .search-result-item-list {
    max-height: 144px;
    overflow-y: scroll;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
  }

  .search-result-item-first-name {
    width: 28px;
    height: 28px;
    line-height: 28px;
    border-radius: 50%;
    font-size: 12px;
    color: #ffffff;
    margin-right: 10px;
  }

  .search-result-item-checkbox {
    margin: 0 15px 0 20px;
  }

  .search-result-item-group {
    opacity: 0.5;
    font-size: 12px;
    color: #000000;
    text-align: left;
    //width: 250px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-left: 6px;
  }
  .search-item-body {
    width: 220px;
    display: flex;
  }

  .search-result-item-name {
    color: #000000;
    text-align: left;
    //width: 250px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    opacity: 0.9;
    font-weight: normal;
    font-size: 13px;
    padding-left: 6px;
  }

  .contact-tree {
    // overflow-x: hidden;
    // -ms-overflow-style: none;
    // scrollbar-width: none;
    // -webkit-box-orient: vertical;
    // -webkit-box-direction: normal;
    height: 370px;
    text-align: left;
    &-head {
      display: flex;
      align-items: center;
      svg {
        margin: 0 12px;
      }
    }
    &-body {
      width: 100%;
      position: relative;
      height: 349px;
      &-list {
        width: 100%;
        overflow: hidden;
        overflow-anchor: none;
        height: 100%;
        max-height: 349px;
        position: relative;
        &-holder {
          position: relative;
          overflow: hidden;
          &-inner {
            padding: 0 20px;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;

            &-item {
              height: 40px;
              padding: 8px 0;
              display: flex;
              justify-content: space-between;
              align-items: center;
              cursor: pointer;
              user-select: none;
              position: relative;
              // &::before {
              //   height: 28px;
              //   position: absolute;
              //   right: 0;
              //   left: 0;
              //   transition: all 0.3s;
              //   content: "";
              // }
              // &:hover::before {
              //   background: #e6f7ff;
              // }
              &-left {
                display: flex;
                align-items: center;

                .open {
                  svg {
                    transform: rotate(90deg);
                  }
                }
                > span {
                  display: flex;
                  align-items: center;
                  width: 24px;
                  height: 24px;
                  line-height: 24px;
                  .caret {
                    svg {
                      width: 10px;
                      height: 10px;
                      transition: transform 0.3s;
                    }
                  }
                }
                .name-color-container {
                  position: relative;
                  width: 28px;
                  height: 24px;
                  .name-color {
                    position: absolute;
                    left: -6px;
                    width: 28px;
                    height: 28px;
                    line-height: 28px;
                    border-radius: 50%;
                    font-size: 12px;
                    color: #ffffff;
                    margin-right: 10px;
                    text-align: center;
                  }
                }
                &-name-overflow {
                  width: 250px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                }
                .name-container {
                  display: flex;
                  align-items: center;
                  .item-text {
                    font-size: 13px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    line-height: 28px;
                  }
                  .item-name {
                    padding-left: 6px;
                    min-width: 60px;
                  }
                }
              }
              &-right {
                span {
                  display: block;
                  width: 16px;
                  height: 16px;
                  border-radius: 50%;
                  border: 1px solid #d9d9d9;
                  background-color: #fff;
                  position: relative;
                  top: 0;
                  left: 0;
                  -webkit-transition: all 0.3s;
                  transition: all 0.3s;
                }
                .check {
                  background-color: #1890ff;
                  border-color: #1890ff;
                  &::after {
                    position: absolute;
                    display: table;
                    border: 2px solid #fff;
                    border-top: 0;
                    border-left: 0;
                    transform: rotate(45deg) scale(1) translate(-50%, -50%);
                    opacity: 1;
                    transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46)
                      0.1s;
                    content: " ";
                    top: 50%;
                    left: 22%;
                    width: 5.71428571px;
                    height: 9.14285714px;
                  }
                }
                .disabled {
                  background-color: #f5f5f5;
                  border-color: #d9d9d9 !important;
                  &::after {
                    border-color: rgba(0, 0, 0, 0.25);
                  }
                }
              }
            }
          }
        }
      }
      &-scrollbar {
        position: absolute;
        width: 8px;
        top: 0px;
        bottom: 0px;
        right: 0px;
        &-thumb {
          width: 100%;
          min-height: 20px;
          top: 0px;
          left: 0px;
          position: absolute;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 99px;
          cursor: pointer;
          user-select: none;
        }
      }
    }
    > div {
      padding-left: 20px;
    }
  }

  .contact-tree .ant-tree-checkbox {
    float: right;
  }
  .contact-tree .ant-tree-checkbox-inner {
    border-radius: 50%;
  }
  .contact-tree
    .ant-tree-checkbox-indeterminate
    .ant-tree-checkbox-inner::after {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .enterprise-contact-icon {
    width: 24px !important;
    height: 24px !important;
    position: absolute;
    left: 0;
  }

  .contact-tree-file-img {
    height: 16px;
    width: 16px;
  }

  .contact-tree-root-title {
    opacity: 0.9;
    font-size: 14px;
    color: #000000;
    position: absolute;
    left: 10px;
  }

  .enterprise-contact-icon {
    width: 24px;
    height: 24px;
  }

  .contact-choice-list {
    width: 279px;
    overflow-y: scroll;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    height: 100%;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    opacity: 0.7;
    .new-select-node {
      display: inline-block;
      width: 180px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      opacity: 0.9;
      font-weight: normal;
      font-size: 13px;
      padding-left: 6px;
    }
    .new-select-address {
      display: flex;
      width: 170px;
      height: 40px;
      .new-select-address-name {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
        padding-left: 6px;
        min-width: 60px;
        opacity: 0.9;
        font-weight: normal;
        font-size: 13px;
      }
      .new-select-address-phone {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-weight: normal;
        display: inline-block;
        opacity: 0.9;
        font-size: 13px;
      }
    }
  }
  .contact-choice-count {
    margin: 22px 0 22px;
    opacity: 0.9;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.5;
    color: #000000;
    padding: 0 20px 0 20px;
  }

  .contact-choice-item > div {
    height: 40px;
    line-height: 40px;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 0 20px;
  }
  .contact-choice-item > div > span {
    display: flex;
    align-items: center;
  }
  .contact-choice-item > div:hover {
    background-color: rgba(79, 139, 255, 0.08);
  }

  .contact-tree-root {
    opacity: 0.9;
    font-size: 14px;
    color: #000000;
  }
  .contact-choice-item-close-icon {
    cursor: pointer;
    width: 14px !important;
    height: 14px !important;
  }

  .ant-checkbox-inner {
    border-radius: 50%;
  }

  .contact-choice-item-address-first {
    width: 28px;
    height: 28px;
    line-height: 28px;
    border-radius: 50%;
    font-size: 12px;
    color: #ffffff;
    display: inline-block;
    margin-right: 10px;
    text-align: center;
  }

  .ant-tree-title {
    display: inline-block;
    width: 220px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper::before,
  .ant-tree.ant-tree-directory
    .ant-tree-child-tree
    > li
    span.ant-tree-node-content-wrapper::before {
    height: 28px;
  }
  .ant-tree li {
    padding: 8px 0;
  }
}
</style>
